export default __webpack_public_path__ + "676ff499323c6b0849127f1668c8160a.png";